import { observer } from 'mobx-react';
import ParticipantStore from '../../../../../../ParticipantStore';
import { T } from '../../../../../../Translations';
import Modal from '../../../../../Modal';
import LicenseAllocationsStore from '.././Store';
import { Loading, LoadingError, Ready, Submitting, SubmittingError } from '.././Types';
import Body from './Body';
import ParticipantInfo from './ParticipantInfo';

interface Props {
  state: Loading | LoadingError | Ready | Submitting | SubmittingError;
  licenseAllocationsStore: LicenseAllocationsStore;
  participantStore: ParticipantStore;
}

function ModalForm({ licenseAllocationsStore, participantStore, state }: Props) {
  return (
    <Modal close={licenseAllocationsStore.waiting} title="">
      <h2 className="text-xl font-semibold">
        <T kind="Allocate License to Participant" />
      </h2>
      <sub>
        <T kind="Select the licenses you want to allocate." />
      </sub>
      <div className="pt-8 font-semibold">
        <T kind="Participant" />
      </div>
      <ParticipantInfo participantStore={participantStore} />
      <Body
        state={state}
        licenseAllocationsStore={licenseAllocationsStore}
        participantStore={participantStore}
      />
    </Modal>
  );
}

export default observer(ModalForm);
